import { ISession } from '../models/pro-sites';
import { G23Countries } from '../components/common/constants';

export const G23Hook = (session: ISession) => {
    if (G23Countries.includes(session.country)) {
        return true;
    }
    return false;
};
